// extracted by mini-css-extract-plugin
module.exports = {"title":"Errors_title__VvkNH","description":"Errors_description__8Zwz_","link":"Errors_link__OVsfa","linksContainer":"Errors_linksContainer___zgGw"};